import React, { useEffect, useRef, useState } from "react";

import {
    Text,
    View,
    TouchableOpacity,
    Platform,
    ScrollView,
    ViewStyle,
    TextStyle,
    ImageStyle,
    StyleSheet,
    Dimensions,
    Image
} from "react-native";

import Images from "../../../specific/utils/Images";

import AppTheme from "../../utils/Theme";
import * as Constants from "../../utils/Constants";

import * as Navigation from "../../../specific/utils/Navigation/Navigation";

import { useNavigate } from "../../../specific/utils/Navigation/Navigation";
import Main from "../../../specific/components/Main/Main";
import MainOptions from "../../models/MainOptions";
import User from "../../data/user/User";
import SVGView from "../../utils/SvgView";

import Divider from "../../designSystem/Divider/Divider";
import { analyticsEventHpWellBeingResourcesClicked, analyticsEventSectionTrainingCPSClicked, analyticsEventSectionTrainingPhiloClicked, propertiesEventProfile, propertiesEventSource, trackEvent } from "../../services/Tracking/Analytics";
import { default as IcDismiss } from "../../../shared/assets/svg/icons/solid/times.svg";
import InViewModal from "../../../specific/components/InViewModal/InViewModal";

import { openUrl } from "../../utils/WebLink";
import StartingSteps from "./StartingSteps";
import ActivityIndicator from "../../designSystem/ActivityIndicator/ActivityIndicator";
import { News } from "../../models/Models";
import { getLocalNews } from "../../../specific/utils/LocalStorage";
import { getLanguage, translate } from "../../utils/Localization/Localization";
import NavBarTitle from "../NavBar/NavBarTitle";
import Button from "../../designSystem/Button";
import Modal from "../../../specific/components/Modal/Modal";
import { IcArobas, IcInstagram } from "../../utils/Icons";

export const KEYS = {
    info: "info",
    profile: "profile",
    path: "path",
    still: "still",
    grow: "grow",
    talk: "talk",
    liliAtSchool: "liliAtSchool",
    superPower: "superPower",
    liliAtHome: "liliAtHome",
    trainingPath: "trainingPath",
    sleepingMeditation: "sleepingMeditation",
    coachingManual: "coachingManual",
    wellBeing: "wellBeing",
    philo: "phi_questions",
    cps: "cps"
}

type DesignElement = {
    pictoBgImage: any,
    headerImage: any,
    headerDecoImage: any,
    mainBackgroundColor: string,
    headerBackgroundColor: string,
    headerTextColor: string,
    itemsColor: string,
    itemsTextColor: string,
    socialButtonBackground: string,
    pageTitle: {
        firstPart: string,
        secondPart: string
    },
    wellBeingSectionTitle: string,
    wellBeingSectionBody: string,
    premiumTitle: string,
    premiumBody: string,
    premiumButtonTitle: string,
    premiumIcon: any,
    premiumIllustration: any
}

export type PDFDocument = {
    title: string,
    url: string,
    color: string
}

type ROOM_CELL_TYPE = "WEBINAR" | "ACTU" | "COMITY" | "LECTURE" | "MANIFESTO" | "ANIMATION_PROJECT" | "WITNESS" | "MODELS" | "SLEEPING";

const SuperRoom = (props: any) => {
    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();
    const user: User = User.getInstance();
    const [viewDidAppear, setViewDidAppear] = useState<boolean>(false);
    const [newsToDisplay, setNewsToDisplay] = useState<News[] | undefined>(undefined);
    const [showHelpSteps, setShowHelpSteps] = useState<boolean>(false);

    let navigate = null;
    if (Platform.OS === "web") {
        navigate = useNavigate()
    }

    const inViewModal = useRef<InViewModal>(null);

    const teacherDesignElements: DesignElement = {
        pictoBgImage: images.bgTeacherPictos,
        headerImage: images.illHeaderTeacherRoom,
        headerDecoImage: images.icHeaderTeacherBoard,
        mainBackgroundColor: "#FFEBDE",
        headerBackgroundColor: "#716899",
        headerTextColor: "#FFFFFF",
        itemsColor: appTheme.schoolColor,
        itemsTextColor: appTheme.white,
        socialButtonBackground: appTheme.schoolColor,
        pageTitle: {
            firstPart: "La salle des",
            secondPart: "super-profs"
        },
        wellBeingSectionTitle: "Module bien-être\ndes super-profs",
        wellBeingSectionBody: "Respirer, se détendre, réduire son stress, croire en soi… Parce que votre bien-être est aussi essentiel que celui de vos élèves, Lili a conçu un programme spécialement pour vous !",
        premiumTitle: "Profitez de l’intégralité des activités et des modules d’accompagnement",
        premiumBody: "avec Lili à l’école Premium\nà partir de 54€ TTC (pour 3 mois)",
        premiumButtonTitle: "Je souscris à \nLili à l’école Premium",
        premiumIcon: images.icLiliAtSchoolCircle,
        premiumIllustration: images.icParentsPremium
    }

    const familyDesignElements: DesignElement = {
        pictoBgImage: images.bgParentsPictos,
        headerImage: images.illHeaderParentsRoom,
        headerDecoImage: images.icHeaderParentsWindow,
        mainBackgroundColor: "#354F84",
        headerBackgroundColor: "#1C3656",
        headerTextColor: "#FFFFFF",
        itemsColor: appTheme.homeColor,
        itemsTextColor: appTheme.white,
        socialButtonBackground: appTheme.darkBlue,
        pageTitle: {
            firstPart: "Le coin des",
            secondPart: "super-parents"
        },
        wellBeingSectionTitle: "Module bien-être\ndes super-parents",
        wellBeingSectionBody: "Respirer, se détendre, réduire son stress, croire en soi… Parce que votre bien-être est aussi essentiel que celui de votre enfant, Lili a conçu un programme spécialement pour vous !",
        premiumTitle: "J’abonne mon super-héros pour l’aider à libérer pleinement ses super-pouvoirs",
        premiumBody: "7 jours gratuits\npuis 4,99€ / mois\nou 35,99€ / an",
        premiumButtonTitle: "J’abonne mon super-héros",
        premiumIcon: images.icLiliAtHomeCircle,
        premiumIllustration: images.illSupercatStanding
    };

    const animatorDesignElements: DesignElement = {
        pictoBgImage: images.bgAnimatorPictos,
        headerImage: images.illHeaderAnimatorsRoom,
        headerDecoImage: images.icHeaderAnimatorsWindow,
        mainBackgroundColor: "#FFEBDE",
        headerBackgroundColor: "#FFFFFF",
        headerTextColor: "#57537F",
        itemsColor: appTheme.schoolColor,
        itemsTextColor: appTheme.white,
        socialButtonBackground: appTheme.animatorColor,
        pageTitle: {
            firstPart: "Le coin des",
            secondPart: "super-anims"
        },
        wellBeingSectionTitle: "Module bien-être\ndes super-anims",
        wellBeingSectionBody: "Respirer, se détendre, réduire son stress, croire en soi… Parce que votre bien-être est aussi essentiel que celui des enfants, Lili a conçu un programme spécialement pour vous !",
        premiumTitle: "",
        premiumBody: "",
        premiumButtonTitle: "",
        premiumIcon: images.icLiliAtHomeCircle,
        premiumIllustration: images.illSupercatStanding
    }

    const designElementsByProfile = {
        "teacher": teacherDesignElements,
        "family": familyDesignElements,
        "animator": animatorDesignElements,
        "default": familyDesignElements
    }

    const designElements: DesignElement = designElementsByProfile[user.profile] !== undefined ? designElementsByProfile[user.profile] : designElementsByProfile["default"];

    // MainOptions
    const { componentId = "", onCloseRequest } = props;

    // Définition de la largeur des blocks
    let blocksWidth: number = appTheme.getFullAppWidth() - appTheme.pixelPerfect(20);
    let bottomBlocksWidth: number = Platform.OS === "web" ? 430 : blocksWidth;
    const screenWidth: number = Dimensions.get("window").width - 200;

    if (appTheme.getFlexDirectionForSplitScreen() === "row") {
        // On enlève la sidebar
        if (screenWidth > 1536) {
            blocksWidth = 728;
        } else if (screenWidth > 1024) {
            blocksWidth = 472;
        } else if (screenWidth > 768) {
            blocksWidth = 344;
        }
    } else if (Platform.OS === "web") {
        if (blocksWidth > 600) {
            blocksWidth = 600;
        }
    }
    const paddingTopForBlocks = Platform.OS === "web" ? 20 : 20;

    // Définition de la largeur des blocks du bas



    let mainOptions: MainOptions = new MainOptions({
        key: "super_teachers_room",
        componentId: props.componentId,
        navigationColor: user.profile === "animator" ? designElements.mainBackgroundColor : designElements.headerBackgroundColor,
        showNavBar: false,
        showMenu: false,
        canBeHidden: false,
        safeArea: false,
        canGoBack: false,
        canBeDismissed: false
    });
    if ((Platform.OS === "web") && (onCloseRequest !== undefined)) {
        mainOptions.canBeHidden = false;
        mainOptions.rightButtonIcon = IcDismiss;
        mainOptions.rightButtonAction = () => onCloseRequest();
    }

    const onViewDidAppear = () => {
        if ((props.path !== undefined) && (props.path.length > 0)) {
            if (props.path === "sub") {
                showUserProfile(props.path, props.stripe);
            } else if (props.path.includes("cardActivation")) {
                showUserProfile(props.path);
            } else if (props.path === "philo") {
                launchSection(KEYS.philo)
            } else if (props.path === "cps") {
                launchSection(KEYS.cps)
            } else if (props.path === "well_being") {
                launchSection(KEYS.wellBeing)
            } else if (props.path === "activity_types") {
                const activityKey: string = "ADV_05";
                const passProps = {
                    activityKey,
                    categoryKey: "onboarding_advices",
                    sectionKey: "onboardingSteps",
                    context: user.profile
                };
                //trackEvent(analyticsEventActivityClicked, { [propertiesEventName]: analytics_key, [propertiesEventCategory]: category.analytics_key });
                if (Platform.OS === "web") {
                    inViewModal.current?.showAlert({
                        name: Constants.ScreenActivitySheet,
                        passProps
                    });
                } else {
                    Navigation.push({
                        componentId,
                        navigate,
                        passProps,
                        name: Constants.ScreenActivitySheet
                    })
                }
            }
        }
        checkNewsToDisplay();
    }

    const checkNewsToDisplay = async () => {
        let localNewsToDisplay: News[] = [];
        try {
            const localNews = await getLocalNews();
            if (localNews.data !== undefined) {
                const localNewsData = localNews.data;
                for (const aNewsKey in localNewsData) {
                    if (Object.prototype.hasOwnProperty.call(localNewsData, aNewsKey)) {
                        const aNews: News = localNewsData[aNewsKey];
                        const now: number = new Date().getTime();
                        if (aNews.status === "published") {
                            if ((aNews.from < now) && (aNews.to > now)) {
                                if (aNews.target.indexOf(user.profile) !== -1) {
                                    localNewsToDisplay.push(aNews);
                                    break;
                                }
                            }
                        }
                    }
                }
                setNewsToDisplay(localNewsToDisplay);
            } else {
                setNewsToDisplay(localNewsToDisplay);
            }
        } catch (error) {
            setNewsToDisplay(localNewsToDisplay);
        }
    }

    useEffect(() => {
        if (newsToDisplay !== undefined) {
            setViewDidAppear(true);
        }
    }, [newsToDisplay]);

    const showUserProfile = (path?: string, stripe?: { subId: string, status: string }) => {
        Navigation.showModalInView({
            componentId,
            name: Constants.ScreenUserProfile,
            passProps: {
                isTeacher: true,
                path,
                stripe
            }
        });
    }

    const showAboutPage = () => {
        Navigation.showModalInView({
            componentId,
            name: Constants.ScreenAbout,
            passProps: {
                isTeacher: true
            }
        });
    }

    let headerWidth = Platform.OS === "web" ? appTheme.getFullAppWidth() : appTheme.getFullAppWidth();
    if (headerWidth > 1920) {
        headerWidth = 1920;
    }

    const sectionBlockWidth = ((Platform.OS === "web") && (appTheme.getFlexDirectionForSplitScreen() === "row")) ? 2 * blocksWidth : blocksWidth;

    const sectionTitleStyle: TextStyle = {
        fontFamily: appTheme.superHerosFontBold,
        fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(15) : appTheme.pixelPerfectForFont(12),
        color: appTheme.darkBlue,
        textAlign: "center",
        marginTop: 20,
        paddingHorizontal: 10
    }

    const sectionBodyStyle: TextStyle = {
        fontFamily: appTheme.primarySemiBoldFont,
        fontSize: Platform.OS === "web" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(11),
        color: appTheme.darkBlue,
        paddingHorizontal: appTheme.pixelPerfect(20),
        textAlign: "center"
    }

    const sectionImageStyle: ImageStyle = {
        width: bottomBlocksWidth,
        height: Platform.OS === "web" ? bottomBlocksWidth * 7 / 16 : bottomBlocksWidth * 7 / 16
    }

    const launchSection = (key: string) => {
        if (key === KEYS.wellBeing) {
            trackEvent(analyticsEventHpWellBeingResourcesClicked);
        } else if (key === KEYS.philo) {
            trackEvent(analyticsEventSectionTrainingPhiloClicked);
        } else if (key === KEYS.cps) {
            trackEvent(analyticsEventSectionTrainingCPSClicked);
        }
        Navigation.push({
            componentId,
            navigate,
            name: Constants.ScreenCategoryHome,
            passProps: {
                categoryKey: key,
                section: "room",
                origin: "menu"
            }
        });
    }

    const renderRelaxationSection = () => {
        return <View style={{ alignItems: "center", justifyContent: "center", width: bottomBlocksWidth, flexDirection: "row" }}>
            <View style={{ alignItems: "center", justifyContent: "flex-start", width: bottomBlocksWidth, paddingTop: appTheme.pixelPerfect(paddingTopForBlocks) }}>
                <TouchableOpacity onPress={() => launchSection(KEYS.wellBeing)} style={{ paddingBottom: appTheme.pixelPerfect(20), width: bottomBlocksWidth, backgroundColor: "#A2F2F8", borderRadius: appTheme.pixelPerfect(30), alignItems: "center", overflow: "hidden" }}>
                    <Image source={require("../../assets/img/rooms/ill_bien_etre.png")} style={sectionImageStyle} />
                    <Text style={sectionTitleStyle}>{translate.labels().rooms.auto_trainings.well_being[user.profile].title}</Text>
                    <Divider />
                    <Text style={sectionBodyStyle}>{translate.labels().rooms.auto_trainings.well_being[user.profile].body}</Text>
                </TouchableOpacity>
            </View>
        </View>
    }

    const renderCPSSection = () => {
        const marginEnd: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfect(20) : 0;
        return <View style={{ marginEnd, alignItems: "center", justifyContent: "center", width: bottomBlocksWidth, flexDirection: "row" }}>
            <View style={{ alignItems: "center", justifyContent: "flex-start", width: bottomBlocksWidth, paddingTop: appTheme.pixelPerfect(paddingTopForBlocks) }}>
                <TouchableOpacity onPress={() => launchSection(KEYS.cps)} style={{ paddingBottom: appTheme.pixelPerfect(20), width: bottomBlocksWidth, backgroundColor: appTheme.cps, borderRadius: appTheme.pixelPerfect(30), alignItems: "center", overflow: "hidden" }}>
                    <Image source={require("../../assets/img/cat_cps.png")} style={sectionImageStyle} />
                    <Text style={sectionTitleStyle}>{translate.labels().rooms.auto_trainings.cps.title}</Text>
                    <Divider />
                    <Text style={sectionBodyStyle}>{translate.labels().rooms.auto_trainings.cps.body}</Text>
                </TouchableOpacity>
            </View>
        </View>
    }

    const renderPhiloSection = () => {
        if ((user.profile === "teacher") || (user.profile === "animator")) {
            const marginEnd: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfect(20) : 0;
            const headerPhiloImage = user.profile === "teacher" ? require("../../assets/img/rooms/ill_lae_auto_formation_philo.png") : require("../../assets/img/rooms/ill_lep_auto_formation_philo.png");
            return <View style={{ marginEnd, alignItems: "center", justifyContent: "center", width: bottomBlocksWidth, flexDirection: "row" }}>
                <View style={{ alignItems: "center", justifyContent: "flex-start", width: bottomBlocksWidth, paddingTop: appTheme.pixelPerfect(paddingTopForBlocks) }}>
                    <TouchableOpacity onPress={() => launchSection(KEYS.philo)} style={{ paddingBottom: appTheme.pixelPerfect(20), width: bottomBlocksWidth, backgroundColor: "#5DD9B5", borderRadius: appTheme.pixelPerfect(30), alignItems: "center", overflow: "hidden" }}>
                        <Image source={headerPhiloImage} style={sectionImageStyle} />
                        <Text style={sectionTitleStyle}>{translate.labels().rooms.auto_trainings.philo.title}</Text>
                        <Divider />
                        <Text style={sectionBodyStyle}>{translate.labels().rooms.auto_trainings.philo.body}</Text>
                    </TouchableOpacity>
                </View>
            </View>
        }
        return <View />
    }

    const renderRoomCell = (cellType: ROOM_CELL_TYPE) => {
        if (cellType === "ACTU") {
            if ((newsToDisplay === undefined) || ((newsToDisplay !== undefined) && (newsToDisplay.length === 0))) {
                return <View />;
            }
        }
        const cellHeight: number = ((blocksWidth * 775 / 668) - appTheme.pixelPerfect(45)) / 4;
        const borderRadius: number = cellHeight * 0.2;
        let cellLink: string = "https://lili.cool";
        let cellTitle: string = "";
        let cellSubtitle: string = "";
        let cellImageSource: number | { uri: string } = require("../../assets/img/navigation/nav_icon_salle_profs.png")
        if (cellType === "WEBINAR") {
            cellLink = translate.labels().rooms.actus.webinar.link;
            cellTitle = translate.labels().rooms.actus.webinar.title;
            cellSubtitle = translate.labels().rooms.actus.webinar.body;
            cellImageSource = require("../../assets/img/rooms/ic_webinar.jpg");
        } else if (cellType === "ACTU") {
            cellLink = newsToDisplay[0].url[getLanguage()]
            cellTitle = `À L’ACTU :\n${newsToDisplay[0].title[getLanguage()]}`;
            cellSubtitle = newsToDisplay[0].body[getLanguage()];
            cellImageSource = { uri: newsToDisplay[0].img };
        } else if (cellType === "COMITY") {
            cellLink = translate.labels().rooms.actus.comity.link;
            cellTitle = translate.labels().rooms.actus.comity.title;
            cellSubtitle = translate.labels().rooms.actus.comity.body;
            cellImageSource = require("../../assets/img/rooms/ic_comity.png");
        } else if (cellType === "LECTURE") {
            cellLink = translate.labels().rooms.actus.read_advice.link;
            cellTitle = translate.labels().rooms.actus.read_advice.title;
            cellSubtitle = translate.labels().rooms.actus.read_advice.body;
            cellImageSource = require("../../assets/img/rooms/ic_charivari.jpg");
        } else if (cellType === "WITNESS") {
            cellLink = translate.labels().rooms.actus.witness.link;
            cellTitle = translate.labels().rooms.actus.witness.title;
            cellSubtitle = translate.labels().rooms.actus.witness.body;
            cellImageSource = require("../../assets/img/rooms/ic_parole-super-anim.jpg");
        } else if (cellType === "ANIMATION_PROJECT") {
            cellLink = translate.labels().rooms.actus.animation_project.link;
            cellTitle = translate.labels().rooms.actus.animation_project.title;
            cellSubtitle = translate.labels().rooms.actus.animation_project.body;
            cellImageSource = require("../../assets/img/rooms/ic_seven_projects.jpg");
        } else if (cellType === "MANIFESTO") {
            cellLink = translate.labels().rooms.actus.manifesto.link;
            cellTitle = translate.labels().rooms.actus.manifesto.title;
            cellSubtitle = translate.labels().rooms.actus.manifesto.body;
            cellImageSource = require("../../assets/img/rooms/ic_manifesto.png");
        } else if (cellType === "SLEEPING") {
            cellLink = translate.labels().rooms.actus.sleep_advice.link;
            cellTitle = translate.labels().rooms.actus.sleep_advice.title;
            cellSubtitle = translate.labels().rooms.actus.sleep_advice.body;
            cellImageSource = require("../../assets/img/rooms/ic_sommeil.jpg");
        } else if (cellType === "MODELS") {
            cellLink = translate.labels().rooms.actus.models.link;
            cellTitle = translate.labels().rooms.actus.models.title;
            cellSubtitle = translate.labels().rooms.actus.models.body;
            cellImageSource = require("../../assets/img/rooms/ic_role_models.jpg");
        }
        const titleFontSize: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfectForFont(10) : appTheme.pixelPerfectForFont(7);
        const subtitleFontSize: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfectForFont(9) : appTheme.pixelPerfectForFont(7);
        return <TouchableOpacity key={cellType} onPress={() => openUrl(cellLink)} style={{ width: blocksWidth, marginBottom: appTheme.pixelPerfect(15) }}>
            <View style={{ flexDirection: "row", width: blocksWidth, backgroundColor: appTheme.white, borderRadius: borderRadius, padding: cellHeight * 0.05, alignItems: "center" }}>
                <Image source={cellImageSource} style={{ width: cellHeight * 0.95, height: cellHeight * 0.95, borderRadius: borderRadius - 4 }} />
                <View style={{ flex: 1, paddingStart: appTheme.pixelPerfect(10) }}>
                    <Text numberOfLines={2} style={{ textTransform: "uppercase", fontFamily: appTheme.primaryBoldFont, color: appTheme.darkBlue, fontSize: titleFontSize, paddingEnd: appTheme.pixelPerfect(10) }}>
                        {cellTitle}
                    </Text>
                    <Text numberOfLines={2} style={{ paddingVertical: 2, fontFamily: appTheme.primaryFont, color: appTheme.darkBlue, fontSize: subtitleFontSize }}>
                        {cellSubtitle}
                    </Text>
                </View>
            </View>
        </TouchableOpacity>
    }

    const renderRoomHelpSection = () => {
        return <StartingSteps
            newsSection={<View />}
            designElements={designElements}
            showAtLaunch={((props.path !== undefined) && (props.path === "advices"))}
            componentId={componentId}
            width={blocksWidth}
            height={blocksWidth} />
    }

    const renderTrainingsSection = () => {
        if (user.profile === "family") {
            return <View />
        }
        let trainingSectionWidth: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfect(40) + bottomBlocksWidth * 3 : blocksWidth;
        const imageContainerWidth: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? 520 : blocksWidth - appTheme.pixelPerfect(40);
        if (Platform.OS === "web") {
if (trainingSectionWidth > screenWidth) {
            trainingSectionWidth = screenWidth - appTheme.pixelPerfect(20);
        }
        }
        
        const imageWidth: number = (imageContainerWidth + 30) / 2;
        const imageHeight: number = imageWidth * 207 / 275;
        const imageContainerHeight: number = imageHeight + 40;
        const imageBorderRadius: number = 30 * imageHeight / 207;
        return <View style={{ marginTop: appTheme.pixelPerfect(30), width: trainingSectionWidth, paddingHorizontal: appTheme.pixelPerfect(20), paddingVertical: appTheme.pixelPerfect(10), flexDirection: appTheme.getFlexDirectionForSplitScreen(), backgroundColor: "#FFFFFF", borderRadius: appTheme.pixelPerfect(30) }}>
            <View style={{ width: imageContainerWidth, height: imageContainerHeight, marginVertical: 20 }}>
                <Image source={require("../../assets/img/rooms/photo_emilie.jpg")} style={{ position: "absolute", bottom: 0, right: 0, width: imageWidth, height: imageHeight, borderRadius: imageBorderRadius, borderWidth: 6, borderColor: "#FFFFFF", transform: [{ rotate: '+7deg' }] }} />
                <Image source={require("../../assets/img/rooms/photo_sarah.jpg")} style={{ position: "absolute", top: 0, left: 0, width: imageWidth, height: imageHeight, borderRadius: imageBorderRadius, borderWidth: 6, borderColor: "#FFFFFF", transform: [{ rotate: '-7deg' }] }} />
            </View>
            <View style={{ flex: 1, paddingHorizontal: 20, alignItems: "center" }}>
                <Text style={sectionTitleStyle}>{translate.labels().rooms.trainings.title}</Text>
                <Divider />
                <Text style={[sectionBodyStyle, { fontFamily: appTheme.primaryMediumFont }]}>{translate.labels().rooms.trainings.body}</Text>
                <Divider />
                <Button onPress={() => openUrl(translate.labels().rooms.trainings.link)} style={{ backgroundColor: appTheme.talk, width: appTheme.pixelPerfect(130), marginVertical: 20 }} title={translate.labels().rooms.trainings.button} />
            </View>
        </View>
    }

    const renderContactSection = () => {
        const trainingSectionWidth: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? bottomBlocksWidth * 3 - appTheme.pixelPerfect(80) : blocksWidth;
        let imageSize: number = (trainingSectionWidth - appTheme.pixelPerfect(60)) / 5;
        if (imageSize > 100) {
            imageSize = 100;
        }
        let title: string = "Rejoignez la communauté des super-profs";
        let savButton: React.JSX.Element | null = <TouchableOpacity onPress={() => openUrl("https://app.livestorm.co/lilicool/webinar-daccompagnement-a-la-pratique-de-lili")}>
            <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_sav.png")} style={{ width: imageSize * 1.3, height: (imageSize * 1.3) * 380 / 563 }} />
        </TouchableOpacity>;
        if (user.profile === "animator") {
            title = "Rejoignez la communauté des super-anims";
        } else if (user.profile === "family") {
            title = "Rejoignez la communauté des super-parents";
            savButton = null;
        }
        return <View style={{ width: trainingSectionWidth, alignItems: "center" }}>
            <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), textAlign: "center", textTransform: "uppercase", color: user.profile === "family" ? "#FFFFFF" : appTheme.darkBlue }}>{title}</Text>
            <View style={{ width: trainingSectionWidth, marginVertical: 20, flexDirection: "row", justifyContent: "space-between" }}>
                <TouchableOpacity onPress={() => openUrl("https://www.instagram.com/lili.cool.app/")} style={{ width: imageSize, height: imageSize, justifyContent: "center", alignItems: "center" }}>
                    <View style={{ width: imageSize - 20, height: imageSize - 20, backgroundColor: appTheme.talk, borderRadius: (imageSize - 20) / 2, justifyContent: "center", alignItems: "center" }}>
                        <SVGView Component={IcInstagram} size={(imageSize - 20) / 2} color="#FFFFFF" />
                    </View>
                </TouchableOpacity>
                <TouchableOpacity onPress={() => openUrl("https://www.lili.cool/fr/#bottom_nl")}>
                    <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_newsletter.png")} style={{ width: imageSize, height: imageSize * 216 / 204 }} />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => openUrl("https://www.lili.cool/fr/le-blog-de-lili/")}>
                    <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_blog.png")} style={{ width: imageSize, height: imageSize * 190 / 203 }} />
                </TouchableOpacity>
                {savButton}
                <TouchableOpacity style={{ width: imageSize, height: imageSize, justifyContent: "center", alignItems: "center" }} onPress={() => openUrl("https://www.lili.cool/fr/contact/")}>
                    <View style={{ width: imageSize - 20, height: imageSize - 20, backgroundColor: appTheme.talk, borderRadius: (imageSize - 20) / 2, justifyContent: "center", alignItems: "center" }}>
                        <SVGView Component={IcArobas} size={(imageSize - 20) / 2} color="#FFFFFF" />
                    </View>
                    <Image resizeMode="contain" source={require("../../assets/img/rooms/ic_plane.png")} style={{ width: imageSize / 2, height: imageSize / 2, position: "absolute", bottom: 0, right: 0 }} />
                </TouchableOpacity>
            </View>
        </View>
    }

    const footerPaddingBottom = appTheme.bottomInsets + appTheme.pixelPerfect(10);

    const getContent = () => {
        if (viewDidAppear === false) {
            return <View onLayout={onViewDidAppear} style={{ alignItems: "center", justifyContent: "flex-start", backgroundColor: designElements.headerBackgroundColor, flex: 1, width: appTheme.getFullAppWidth() }}>
                <ActivityIndicator loading={true} color={appTheme.primaryColor} />
            </View>
        }
        const firstBlockJustifyContent: "center" | "flex-start" = appTheme.getFlexDirectionForSplitScreen() === "row" ? "center" : "flex-start";
        const firstBlockAlignItems: "center" | "flex-start" = appTheme.getFlexDirectionForSplitScreen() === "row" ? "flex-start" : "center";
        let roomCells: React.JSX.Element[] = [];
        if (user.profile === "family") {
            roomCells = [
                renderRoomCell("SLEEPING"),
                renderRoomCell("MODELS"),
                renderRoomCell("COMITY"),
                renderRoomCell("MANIFESTO")

            ]
        } else if (user.profile === "teacher") {
            roomCells = [
                renderRoomCell("WEBINAR"),
                renderRoomCell("COMITY"),
                renderRoomCell("LECTURE"),
                renderRoomCell("ACTU")
            ]
        } else if (user.profile === "animator") {
            roomCells = [
                renderRoomCell("WEBINAR"),
                renderRoomCell("ANIMATION_PROJECT"),
                renderRoomCell("WITNESS"),
                renderRoomCell("COMITY")
            ]
        }
        const roomCellsMarginTop: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? 0 : appTheme.pixelPerfect(15);
        const marginBetweenFirstBlocks: number = appTheme.getFlexDirectionForSplitScreen() === "row" ? appTheme.pixelPerfect(10) : 0;
        return <View style={{ alignItems: "center", justifyContent: "flex-start", backgroundColor: user.profile === "family" ? appTheme.homeBackgroundColor : appTheme.schoolBackgroundColor, flex: 1, width: appTheme.getFullAppWidth() }}>
            <ScrollView showsVerticalScrollIndicator={false} style={{ marginTop: appTheme.topInsets }}>
                <View style={{ width: appTheme.getFullAppWidth(), alignItems: "center" }}>
                    <NavBarTitle titleColor={user.profile === "family" ? "#FFFFFF" : appTheme.darkBlue} title={`${designElements.pageTitle.firstPart} ${designElements.pageTitle.secondPart}`} showLevel={false} />
                </View>
                <View style={{ alignItems: "center", justifyContent: "flex-start", width: appTheme.getFullAppWidth(), paddingBottom: footerPaddingBottom + appTheme.pixelPerfect(100) }}>
                    <View style={{ flexDirection: appTheme.getFlexDirectionForSplitScreen(), width: appTheme.getFullAppWidth(), justifyContent: firstBlockJustifyContent, alignItems: firstBlockAlignItems }}>
                        <View style={{ marginEnd: marginBetweenFirstBlocks }}>
                            {renderRoomHelpSection()}
                        </View>
                        <View style={{ width: blocksWidth, marginStart: marginBetweenFirstBlocks, marginTop: roomCellsMarginTop }}>
                            {roomCells}
                        </View>
                    </View>
                    <Divider size={20} />
                    <Text style={{ fontFamily: appTheme.primaryBoldFont, fontSize: appTheme.pixelPerfectForFont(12), textTransform: "uppercase", textAlign: "center", color: user.profile === "family" ? "#FFFFFF" : appTheme.darkBlue }}>{translate.labels().rooms.auto_trainings.title[user.profile]}</Text>
                    <View style={{ flexWrap: Platform.OS === "web" ? "wrap" : "nowrap", flexDirection: appTheme.getFlexDirectionForSplitScreen(), alignItems: appTheme.getFlexDirectionForSplitScreen() === "row" ? "flex-start" : "center", justifyContent: "center", width: appTheme.getFullAppWidth() }}>
                        {renderCPSSection()}
                        {renderPhiloSection()}
                        {renderRelaxationSection()}
                    </View>
                    {renderTrainingsSection()}
                    <Divider size={20} />
                    {renderContactSection()}
                </View>
            </ScrollView>
        </View>
    }

    return (
        <Main mainOptions={mainOptions}>
            {getContent()}
            <Modal visible={showHelpSteps} transparent={true} animationType="slide">
                <StartingSteps />
            </Modal>
            <InViewModal ref={inViewModal} />
        </Main>
    )
}

export default SuperRoom;